import {
    HttpRequestMethod,
    ParameterLocation,
    type RemoteApiSpec,
    TargetPlatform,
} from "../../../../gql-generated/types";
import { onlyCameraKitSelected } from "../../../utils/onlyCameraKitSelected";

import {
    type RemoteApiFormValues,
    type ValidMethods,
    type ValidParameterLocations,
    type ValidTargetPlatforms,
} from "./remoteApiSpecSchema";

export const mapRemoteApiSpecToInitialValues = (spec: RemoteApiSpec): RemoteApiFormValues => {
    const {
        id,
        name,
        providerName,
        documentationUrl,
        iconUrl,
        description,
        visibility,
        minLensStudioVersion,
        host,
        maxRequestSizeBytes,
        maxResponseSizeBytes,
        maxResponseTimeMillis,
        orgId,
        snapkitAppId,
        useBuiltinLocalProcessor,

        targetPlatforms,
        endpoints,
        customVisibilityUsersList,
    } = spec;

    const targetPlatformsFiltered = targetPlatforms.filter(
        (platform): platform is ValidTargetPlatforms => platform !== TargetPlatform.TargetPlatformUnset,
    );

    const endpointsFiltered = endpoints.map((endpoint) => {
        const { ...endpointCopy } = endpoint;
        delete endpointCopy.__typename;

        return {
            ...endpointCopy,
            methods: endpoint.methods.filter(
                (method): method is ValidMethods => method !== HttpRequestMethod.MethodUnset,
            ),
            parameters: endpoint.parameters
                .filter((parameter) => parameter.location !== ParameterLocation.LocationUnset)
                .map((parameter) => {
                    const { ...param } = parameter;
                    const required = !param.optional;

                    delete param.__typename;
                    return {
                        ...param,
                        required,
                        location: param.location as ValidParameterLocations,
                    };
                }),
        };
    });

    const userList = customVisibilityUsersList ?? [];

    return {
        id,
        name,
        providerName,
        documentationUrl,
        iconUrl,
        description,
        visibility,
        minLensStudioVersion,
        host,
        maxRequestSizeBytes,
        maxResponseSizeBytes,
        maxResponseTimeMillis,
        orgId,
        snapkitAppId,
        useBuiltinLocalProcessor: onlyCameraKitSelected(targetPlatformsFiltered) ? useBuiltinLocalProcessor : true, // only allow custom processor for camera kit

        targetPlatforms: targetPlatformsFiltered,
        endpoints: endpointsFiltered,
        customVisibilityUsersList: [...userList],
    };
};
